import BaseStore from "@/store/baseDikeTrajectoryStore"

export const namespaced = true

const baseURI = "/reference_points/"
const baseStore = new BaseStore(baseURI)

const getDefaultState = () => {
  return {
    ...baseStore.state,
    status: "empty"

  }
}

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
export const actions = {
  ...baseStore.actions,
  resetState (context) {
    context.commit("resetState")
    context.dispatch("dikeProfiles/resetState", null, { root: true })
  }
}

export const getters = {
  getReferencePointFromId: (state) => (id) => {
    return state.items ? state.items.features.find(referencePoint => referencePoint.properties.geometry_id === id) : null
  },
  leafletItems: (state) => {
    if (!state.items?.features) {
      return null
    }
    const features = JSON.parse(JSON.stringify(state.items.features))
    features?.forEach(feature => {
      if (feature.geometry && feature.geometry.coordinates) {
        const coordinates = feature.geometry.coordinates
        feature.geometry.coordinates = [coordinates[1], coordinates[0]]
      }
    })
    return features
  }

}




